<template>
  <div
    class="hold-transition login-bg theme-default">
   <div class="login-logo-mobile d-block d-sm-none">
                  <img :src="getImage('logo.svg')" alt="Carnival Internet">
   </div>

   <!-- login-container -->
    <div class="login-container">
            <div class="login-img">
                <img :src="getImage('login-bg.png')" alt="Carnival Internet" />
            </div>

            <div v-if="is_form_div_shown">
              <!-- /.login-logo -->
              <div class="login-box-body">
              <router-link class="back-link" :to="{name: 'Login'}">
              <i class="fas fa-angle-left"></i> Back to login
              </router-link>
              <div class="login-logo d-none d-sm-block">
              <a href="https://stage-site.carnival.com.bd/admin">
                  <span class="logo-lg">
                      <img :src="getImage('logo.svg')" alt="Carnival Internet">
                  </span>
              </a>
              </div>
              <h2>Reset Password</h2>

              <div class="overlay text-center" v-if="is_loading">
              <i class="fas fa-2x fa-sync-alt fa-spin"></i>
              </div>

              <form @submit.prevent="reset_pass()" method="POST" novalidate>
              
                <div class="form-group mb-3">
                    <label class="control-label">New Password</label>
                    <input type="password" name="password" v-model.trim="resetPassInfo.password" class="form-control"
                            placeholder="Password" v-validate="'required'" ref="password"
                            :class="{'has-error' : errors.has('password')}">
                    <div class="help text-danger" v-show="errors.has('password')">
                      {{ errors.first('password') }}
                    </div>
                </div>

                <div class="form-group mb-3">
                    <label class="control-label">Confirm Password</label>
                    <input type="password" name="password_confirmation" v-model.trim="resetPassInfo.password_confirmation"
                            class="form-control" placeholder="Confirm Password" v-validate="'required|confirmed:password'"
                            data-vv-as="password" :class="{'has-error' : errors.has('password_confirmation')}">
                    <div class="help text-danger" v-show="errors.has('password_confirmation')">
                      {{ errors.first('password_confirmation') }}
                    </div>
                </div>

                <div class="form-group">
                    <div class="response-alert"></div>
                </div>

                <button type="submit" class="btn btn-common btn-block btn-login">Reset Password <i class="fas fa-arrow-right"></i>
                </button>
              
            </form>

              </div>
              <!-- end of login-logo -->   
            </div>
            <div class="login-box-body expired_message" v-else>
                <div class="row justify-content-center">
                  <div class="col-md-6" v-html="message">
                  
                  </div>
                </div>
            </div>
      
    </div>
    <!-- end of login-container -->
  </div>
</template>
<style>
.v-toaster .v-toast.v-toast-error{
    color: #721c24;
    background-color: #f8d7da !important;
    border-color: #f5c6cb !important;
}

.v-toaster .v-toast.v-toast-success{
  color: #fff;
  background-color: #28a745 !important;
  border-color: #23923d !important;
}
</style>
<script>
import GuestLayout from '@/components/layouts/GuestLayoutComponent.vue';
import axios from 'axios';
import router from "@/router";
import { forEach } from 'lodash';
import { SelfcareAPI } from '@/services/api';
// import store from "@/store";

export default {
  components: {
    //
  },
  data: () => ({
    resetPassInfo: {
      //send_via: '',
      mobile_or_email: '',
      token: ''
    },
    is_loading: false,
    is_disabled: false,
    is_form_div_shown: false,
    message: ''
  }),
  methods: {

    reset_pass: function (e) {
      // uppercase , lower case , number , special char
      let password = this.resetPassInfo.password;
      let _this = this;
      if(password.length < 8 ){
        _this.$toaster.error('Password should be minimum 8 characters.');
        return; 
      }
      if( !/[A-Z]/.test(password) ){
        _this.$toaster.error('Password should contain at least one uppercase letter.');
        return; 
      }

      if( !/[a-z]/.test(password) ){
        _this.$toaster.error('Password should contain at least one lowercase letter.');
        return; 
      }

      if( !/[0-9]/.test(password) ){
        _this.$toaster.error('Password should contain at least one number.');
        return; 
      }

      if( !/\W+/.test(password) ){
        _this.$toaster.error('Password should contain at least one special character.');
        return; 
      }

      //return;

      _this.$validator.validateAll().then((result) => {
        if (result) {
          let api_url = this.API_BASE_URL + '/auth/reset-password';
          _this.is_loading = true;
          axios({
            method: 'post',
            url: api_url,
            data: this.resetPassInfo
          }).then(function (response) {
            console.log('check response', response);
            if (response.status === 200 && response.data.status === 200 ) {
                // _this.$toaster.success(response.data.message);
                _this.resetPassInfo.password = '';
                _this.resetPassInfo.password_confirmation = '';
                $(".response-alert").html("").prepend($(
                '<div class="help text-success">\n' +
                  response.data.message +
                '</div>'));

                setTimeout(()=>{
                  _this.$router.push({'path': '/login'});
                }, 3500);
               
            } else {
              $(".response-alert").html("").prepend($(
                '<div class="help text-danger">\n' +
                  response.data.message +
                '</div>'));
            }
          }).catch(function (error) {
            if (error.response) {  
                $(".response-alert").html("").prepend($(
                '<div class="help text-danger">\n' +
                  error.response.data.message +
                '</div>'));
            } else if (error.request) {
              // The request was made but no response was received
              console.log(error.request);
            } else {
              // Something happened in setting up the request that triggered an Error
              console.log('Error', error.message);
            }

          }).finally(function () {
            _this.is_loading = false;
            _this.is_disabled = false;
            setTimeout(() => {
              $('.alert').fadeOut('slow');
            }, 5000);
          });
        }
      });
    },

  },
  mounted: function () {
    let params = this.$route.params;
    if (params !== undefined && Object.keys(params).length > 0) {
      this.resetPassInfo.send_via = params.userInfo.send_via;
      this.resetPassInfo.mobile_or_email = params.userInfo.mobile_or_email;
      this.resetPassInfo.token = params.userInfo.token;
    } else {
      // router.push({'path': '/login'});
    }


    // const key = process.env.VUE_APP_AES_KEY;
    // const iv = process.env.VUE_APP_AES_IV;

    // const cryptoRef = this.$CryptoJS;

    // let encrypted = cryptoRef.AES.encrypt('Danial', key, { iv: iv });
  
    // encrypted = encrypted.toString();
    // console.log("Encrypted Text::::", encrypted);
    // let decryptedText = cryptoRef.AES.decrypt(encrypted, key, { iv: iv});
   
    // decryptedText = decryptedText.toString(cryptoRef.enc.Utf8);
    // console.log("Decrypted Text::::", decryptedText);

    if(this.$route.query.token){
        this.resetPassInfo.token = this.$route.query.token;
        console.log("Token Value::::", this.resetPassInfo.token);
    }else{
        //this.$router.push({name: 'ForgotPass'});
    }

    if(this.$route.query.mobile_or_email){
        this.resetPassInfo.mobile_or_email = this.$route.query.mobile_or_email;
        console.log("mobile_or_email Value::::", this.resetPassInfo.mobile_or_email);
    }else{
       // this.$router.push({name: 'ForgotPass'});
    }

    if(this.$route.query.send_via){
        this.resetPassInfo.send_via = this.$route.query.send_via;
        console.log("send_via Value::::", this.resetPassInfo.send_via);
    }else{
        //this.$router.push({name: 'ForgotPass'});
    }

    const keys = Object.keys(this.$route.query);
    let requestParameters = {};
    if(keys.length > 0){
      for(const name of keys){
        requestParameters[name] = this.$route.query[name];
      }
    }

    console.log("Request parameters::::");

    if(Object.keys(requestParameters).length > 0){
      
      SelfcareAPI.checkLinkValidity(requestParameters)
      .then((response)=>{
        //console.log("Response:::", response);
         if(response.status == 200){
             this.is_form_div_shown = true;
         }else{
            this.message = response.message; 
         }
         this.$forceUpdate();
      }).catch((error)=>{

      });

    }


  },
  created() {
    this.$emit('update:layout', GuestLayout)
  }
}
</script>

<style scoped>
.expired_message{
  text-align: center;
    width: auto;
    font-size: 18px;
    line-height: 30px;
    margin: 0px;
    color: #dc3545;
    flex: 1;
}
.input-group-text {
  display: flex;
  align-items: center;
  padding: 0.375rem 0.75rem;
  margin-bottom: 0;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5;
  color: #495057;
  text-align: center;
  white-space: nowrap;
  background-color: #e9ecef;
  border: none !important;
  border-radius: 0.25rem;
}
</style>
